// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SoundFilledSvg from "@fishx/icons-svg/es/asn/SoundFilled";
import FishxIcon from '../components/FishxIcon';

var SoundFilled = function SoundFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SoundFilledSvg
  }));
};

SoundFilled.displayName = 'SoundFilled';
export default React.forwardRef(SoundFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SoundFilled.js
// module id = 4178
// module chunks = 0